<template>
  <div class='h100vh-140'>
    <div class="h-toolbarBg">
      <div class="h-inputBox">
        {{$t("UE.ue_selected")}}:<span id="selectedArea" style="margin-left: 5px"></span>
      </div>
    </div>
    <div class="h-toolbarBg">
      <div class="h-inputBox">
        {{$t("UE.ue_search_imsi")}}:
        <ejs-textbox class="e-input" :placeholder='$t("UE.ue_imsi")' @keyup.enter.native="filterData" v-model="keyString" />
      </div>
    </div>
    <div class="h100-40 h-scroll">
      <ejs-grid ref="grid" height='calc(100vh - 280px)' :allowSelection="true" :selectionSettings="selectionOptions" :checkBoxChange="setProps" :rowDeselected="setProps"
                :rowSelected="setProps" :dataBound="dataBoundFunc">
        <e-columns>
          <e-column type="checkbox" width="50" textAlign="center" ></e-column>
          <e-column field="imsi" :headerText='$t("UE.ue_imsi")' width="180" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="eqAlias" :headerText='$t("UE.ue_base_enodeb")' width="150" textAlign="Center"></e-column>
          <e-column field="stateStr" :headerText='$t("UE.ue_state")' width="60" textAlign="Center"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { Filter } from "@syncfusion/ej2-vue-grids"
import {EventBus} from "../../plugins/eventBus";
export default {
  name: "QueryUeList",
  data() {
    return {
      keyString: "",
      constData:[],
      selectedImsi:[],
      lastSelected:[],
      selectionOptions: { type: 'Multiple' },
    };
  },
  components: {
  },
  methods: {
    setSelectedUe(data){
      if(data != undefined && data.length > 0){
        this.selectedImsi = data;
        this.lastSelected = data;
      }
    },
    setUeList(data) {
      this.constData = data;
      this.$refs.grid.ej2Instances.dataSource = data;
    },
    setProps(){
      this.selectedImsi=[];
      const dom = document.getElementById("selectedArea");
      dom.innerHTML="";
      const data = this.$refs.grid.getSelectedRecords();
      data.forEach(item=>{
        this.selectedImsi.push(item.imsi);
        if(this.selectedImsi.length <= 5){
          let pNode = document.createElement('i');
          pNode.style.marginLeft="10px";
          pNode.textContent =item.imsi;
          dom.appendChild(pNode);
        }
      });
      this.$emit("childProps", {imsi: this.selectedImsi});
    },
    dataBoundFunc() {
      if(this.lastSelected.length == 0){
        return ;
      }
      const indexes = [];
      this.lastSelected.forEach(item => {
        indexes.push(this.constData.findIndex(r => item == r.imsi));
      });
      this.$refs.grid.ej2Instances.selectRows(indexes);
    },
    filterData() {
      if (this.constData == null) {
        return null;
      }
      let filterData = [];
      if(this.keyString.trim().length == 0){
        filterData = this.constData;
      }else{
        this.constData.forEach(e => {
          if (e.imsi.indexOf(this.keyString) != -1) {
            filterData.push(e);
          }
        });
      }
      this.$refs.grid.ej2Instances.dataSource = filterData;
      this.$emit("childProps", {imsi: this.selectedImsi});
    },
  },
  mounted() {
    this.filterData();
  },
  provide: {
    grid: [Filter]
  },
};
</script>
